export const customElement = (elementName) => (iClass) => {
    window.customElements.get(elementName) || window.customElements.define(elementName, iClass);
};
//# sourceMappingURL=PICDecorators.js.map